// Config constants
export const API_BASE =
  import.meta?.env?.VITE_API_BASE ?? "https://deals247.com/rest/examservices";
export const EXEC_APPENDER = import.meta?.env?.VITE_EXEC_TABLE_APPENDER ?? "";
export const PAYMENT_VALIDATOR_URL = "https://zuju49yji3.execute-api.us-west-2.amazonaws.com/prod/validate-payment";
export const PASS_MARK = 70;
export const BUILD_TIME = new Date().toISOString();

// Application Branding - Can be overridden via .env.local
export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || "Pass MLO Exam",
  shortName: import.meta.env.VITE_APP_SHORT_NAME || "PassMLO",
  domain: import.meta.env.VITE_APP_DOMAIN || "passmloexam.com",
  year: import.meta.env.VITE_APP_YEAR || new Date().getFullYear(),
  copyright: `© ${import.meta.env.VITE_APP_YEAR || new Date().getFullYear()} ${import.meta.env.VITE_APP_NAME || "Pass MLO Exam"}. All rights reserved.`
};

export const APP_NAMES = [
  "APBiology",
  "APComputerScience",
  "APEnvironmentalScience",
  "APHumanGeography",
  "APMathematics",
  "APPhysics",
  "APWorldHistory Practice",
  "APPYSCHOLOGY",
  "Apex",
  "AWSAssociateArchitect",
  "AWSAssociateDeveloper",
  "AWSCloudPractionerCLF-C02PracticeExam",
  "AWSDOPProfessionalPracticeQuestions",
  "AWSSecuritySpecialtySCS-C02PracticeExam",
  "AWSDataEngineerDEA-C01PracticeExam",
  "AWSPractice",
  "BackendEngineerInterviewPracticeQuestions",
  "Pass MLO Exam",
  "ComputerScienceCareerCounselling",
  "DataStructures and Algorithms",
  "FinMetry",
  "FHIR",
  "FrontEnd Engineer Interview Questions",
  "Flutter",
  "HonorsChemistry",
  "InterviewLand",
  "JavaLearning",
  "Java SE 21 Practice Questions",
  "Java EE 7 Practice Questions",
  "JavaPatterns",
  "KinesisPractice",
  "KafkaPractice",
  "KubernetesPracticeExams",
  "LawCareerCounselling",
  "LWCWithApex",
  "MBAMarketing",
  "MachineLearningCourse",
  "MedicalCareerCounselling",
  "MotivateMantra",
  "MyTriviaapp",
  "NvidiaAICourse",
  "NextJS Interview Questions",
  "NodeJSAndTypeScript Interview Questions",
  "NMLS Exam Questions",
  "Organize.Coach",
  "AppStoreOptimization",
  "Postgresql Certification Questions",
  "PythonMLandETL",
  "RecruitmentAgency",
  "RiddleWhisper",
  "ReactJS Interview Questions",
  "SaleforcePD2Practice",
  "SaleforcePD2PracticeLive",
  "SaleforcePD2RealPractice",
  "SaleforcePlatformDeveloper1Practice",
  "SaleforceLWCCertificationPractice",
  "SaleforceAuraCertificationPractice",
  "SalesforceDataArchitectCertficationExam",
  "SalesforceDevAndDeploymentLifeCycleExam",
  "SalesforceSaleCloudQuestions",
  "SaleforceAdministrationPractice",
  "SeleniumTestingCourse",
  "SeleniumTestingCoursePro",
  "Spring Certification Practice Questions",
  "StatisticsForMachineLearning",
  "SQLLearningCourse",
  "SwiftAndSwiftIUIApp",
  "SystemArchitect",
  "Terraform",
  "UnityLearningApp",
  "VisualForceertificationPractice",
  "WeightLossKnowledge",
  "WordPress Certification Questions",
].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
